export default "__VITE_ASSET__DM9m0b1g__"